import React, { useState } from "react";
import { Box, Button, Divider, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  authButton,
  backButton,
  bodyContainer,
  buttonContainer,
  container,
  divider,
  googleButton,
  input,
  nextButton,
  subContainer,
  titleText,
} from "./styles";
import { ReactComponent as GoogleIcon } from "../../assets/icons/ic_google.svg";
import { colors } from "../../theme/colors";
import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { auth, db } from "../../services/firebase";
import { getErrorMessage, showToast } from "../../services/toast";
import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { UserType } from "../../types";

const Register = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [confirmEmail, setConfirmEmail] = useState<string>("");
  const [password, setPassowrd] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  const navigate = useNavigate();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  const onCreateUser = async () => {
    if (firstName === "") {
      showToast("You must input first name", "error");
      return;
    }
    if (lastName === "") {
      showToast("You must input last name", "error");
      return;
    }
    if (email === "") {
      showToast("You must input email address", "error");
      return;
    }
    if (confirmEmail === "") {
      showToast("You must confirm your email", "error");
      return;
    }
    if (password === "") {
      showToast("You must input password", "error");
      return;
    }
    if (confirmPassword === "") {
      showToast("You must confirm your password", "error");
      return;
    }
    if (phoneNumber === "") {
      showToast("You must input your phone number", "error");
      return;
    }
    if (email !== confirmEmail) {
      showToast("You confirm email address is not matched", "error");
      return;
    }
    if (password !== confirmPassword) {
      showToast("You confirm password is not matched", "error");
      return;
    }
    setIsLoading(true);
    await createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        addUserData(user.uid);
      })
      .catch((error) => {
        setIsLoading(false);
        const errorCode = error.code;
        const errorMessage = getErrorMessage(errorCode);
        showToast(errorMessage, "error");
      });
  };

  const addUserData = async (uid: string) => {
    try {
      let userData: UserType = {
        uid: uid,
        email: email,
        name: firstName,
        surname: lastName,
        phoneNumber: phoneNumber,
      };
      const docRef = await setDoc(doc(db, `users/${uid}`), userData);
      setIsLoading(false);
      navigate("/");
      navigate(0);
    } catch (e) {
      showToast("Something went long", "error");
    }
  };

  const onGoogleSignUp = async () => {
    setIsLoading(true);
    await signInWithPopup(auth, provider)
      .then(async (result) => {
        setIsLoading(false);
        const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        const user = result.user;
        let userData: UserType = {
          uid: result.user.uid,
          email: user.email ? user.email : "",
          name: user.displayName?.split(" ")[0],
          surname: user.displayName?.split(" ")[1],
          phoneNumber: user.phoneNumber || "",
        };
        const docRef = await setDoc(doc(db, `users/${user.uid}`), userData);
        navigate("/");
        navigate(0);
      })
      .catch((error) => {
        setIsLoading(false);
        // const errorCode = error.code;
        const errorMessage = error.message;
        showToast(errorMessage, "error");
      });
  };

  return (
    <Box sx={(theme) => container(theme)}>
      <Box sx={(theme) => bodyContainer(theme)}>
        <Box sx={(theme) => subContainer(theme)}>
          <Typography sx={(theme) => titleText(theme)}>
            User Information
          </Typography>

          <Box sx={{ width: "100%", p: "20px 0" }}>
            <TextField
              placeholder="First Name"
              size="small"
              fullWidth
              type="text"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <TextField
              placeholder="Last Name"
              size="small"
              fullWidth
              type="text"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <TextField
              placeholder="Email Address"
              size="small"
              fullWidth
              type="email"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              placeholder="Confirm Email Address"
              size="small"
              fullWidth
              type="email"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={confirmEmail}
              onChange={(e) => setConfirmEmail(e.target.value)}
            />
            <TextField
              placeholder="Password"
              size="small"
              fullWidth
              type="password"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={password}
              onChange={(e) => setPassowrd(e.target.value)}
            />
            <TextField
              placeholder="Confirm Password"
              size="small"
              fullWidth
              type="password"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <TextField
              placeholder=" Cellphone Number"
              size="small"
              fullWidth
              type="tel"
              required
              disabled={isLoading}
              sx={(theme) => input(theme)}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />

            <Divider sx={(theme) => divider(theme)}>or</Divider>

            <Button
              fullWidth
              variant="contained"
              disabled={isLoading}
              sx={(theme) => authButton(theme)}
              onClick={() => {
                navigate("/login");
              }}
            >
              Existing User
            </Button>

            <Divider sx={(theme) => divider(theme)}>or continue with</Divider>

            <Button
              fullWidth
              variant="contained"
              startIcon={<GoogleIcon />}
              disabled={isLoading}
              sx={(theme) => googleButton(theme)}
              onClick={() => onGoogleSignUp()}
            >
              Google
            </Button>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "12px",
                color: colors.dark_gray,
                mt: 2,
              }}
            >
              By clicking continue, you agree to our{" "}
              <b style={{ color: "black" }}>Terms of Service</b> and{" "}
              <b style={{ color: "black" }}>Privacy Policy</b>
            </Typography>
          </Box>

          <Box sx={(theme) => buttonContainer(theme)}>
            <Button
              variant="contained"
              disabled={isLoading}
              sx={(theme) => backButton(theme)}
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>

            <Button
              variant="contained"
              disabled={isLoading}
              sx={(theme) => nextButton(theme)}
              onClick={() => onCreateUser()}
            >
              Next
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Register;
